import { createContext, PropsWithChildren, useContext, useState } from 'react';

export interface GetProjectGroupProjects {
  id: string;
  name: string;
}

export const CardGroupUtilContext = createContext(
  {} as {
    activeProjects?: GetProjectGroupProjects[];
    setActiveProjects: React.Dispatch<React.SetStateAction<GetProjectGroupProjects[] | undefined>>;
  }
);

export const useCardUtilContext = () => useContext(CardGroupUtilContext);

export const CardGroupUtilProvider = ({ children }: PropsWithChildren) => {
  const [activeProjects, setActiveProjects] = useState<GetProjectGroupProjects[] | undefined>();

  return (
    <CardGroupUtilContext.Provider value={{ activeProjects, setActiveProjects }}>
      {children}
    </CardGroupUtilContext.Provider>
  );
};
